import React, { Component } from 'react';
import { getSchedule, saveSchedule } from '../utils/reservationsApi';

const WEEKDAYS = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];
const FIELDS = [
  ['openHour', 'Apertura'],
  ['closeHour', 'Cierre'],
  ['lastReservation', 'Última reserva'],
  ['minPlayers', 'Mín. jugadores'],
  ['maxPlayers', 'Máx. jugadores'],
  ['pricePerPlayer', 'Precio por jugador'],
  // ENI-208: tope de reservas vigentes por cuenta desde el storefront (no aplica al
  // walk-in ni a las que carga el local: por teléfono sí se le pueden hacer varias).
  ['maxActiveReservationsPerAccount', 'Máx. reservas vigentes por cliente'],
];

// Configuración del horario de reservas de mesa (config reservation_schedule).
// Vive en el panel de Configuración del admin; los bloqueos puntuales van en el panel de Reservas.
class ReservationSettingsComponent extends Component {
  constructor() {
    super();
    this.state = { schedule: null, loaded: false, busy: false, message: null };
  }

  componentDidMount() {
    this.load();
  }

  load = async () => {
    try {
      const data = await getSchedule();
      this.setState({ schedule: (data && data.schedule) || null, loaded: true });
    } catch (e) {
      this.setState({ loaded: true, message: { type: 'danger', text: e.message } });
    }
  };

  setField = (key, value) => this.setState({ schedule: { ...this.state.schedule, [key]: value } });

  toggleWeekday = (d) => {
    const cur = (this.state.schedule.closedWeekdays || []).map(Number);
    const next = cur.includes(d) ? cur.filter((x) => x !== d) : [...cur, d];
    this.setField('closedWeekdays', next);
  };

  // Horario propio de un día (p. ej. viernes y sábados hasta las 24). Vacío = usa el general.
  setOverride = (day, key, value) => {
    const overrides = { ...(this.state.schedule.weekdayOverrides || {}) };
    const entry = { ...(overrides[String(day)] || {}) };
    if (value === '' || value === null) delete entry[key];
    else entry[key] = Number(value);
    if (Object.keys(entry).length === 0) delete overrides[String(day)];
    else overrides[String(day)] = entry;
    this.setField('weekdayOverrides', overrides);
  };

  overrideValue = (day, key) => {
    const entry = (this.state.schedule.weekdayOverrides || {})[String(day)] || {};
    return entry[key] === undefined || entry[key] === null ? '' : entry[key];
  };

  save = async () => {
    if (this.state.busy) return;
    this.setState({ busy: true, message: null });
    try {
      const data = await saveSchedule(this.state.schedule);
      this.setState({ busy: false, schedule: (data && data.schedule) || this.state.schedule, message: { type: 'success', text: 'Horario guardado.' } });
    } catch (e) {
      this.setState({ busy: false, message: { type: 'danger', text: e.message } });
    }
  };

  render() {
    const { schedule: s, loaded, message } = this.state;
    return (
      <div className="card card-small mb-4">
        <div className="card-header border-bottom"><h6 className="m-0">Horario de reservas</h6></div>
        <div className="card-body">
          {message && <div className={`alert alert-${message.type}`}>{message.text}</div>}
          {!loaded ? (
            <p className="text-muted">Cargando…</p>
          ) : !s ? (
            <p className="text-muted">No se pudo cargar la configuración.</p>
          ) : (
            <div>
              <div className="form-row">
                {FIELDS.map(([key, label]) => (
                  <div className="form-group col-6 col-md-2" key={key}>
                    <label><small>{label}</small></label>
                    <input type="number" className="form-control form-control-sm" value={s[key]}
                      onChange={(e) => this.setField(key, Number(e.target.value))} />
                  </div>
                ))}
              </div>
              <div className="form-group">
                <label className="d-block"><small>Días cerrados</small></label>
                {WEEKDAYS.map((wd, d) => (
                  <label key={d} className="mr-3">
                    <input type="checkbox" checked={(s.closedWeekdays || []).map(Number).includes(d)} onChange={() => this.toggleWeekday(d)} /> {wd}
                  </label>
                ))}
              </div>
              {/* Días con horario propio: lo típico es viernes y sábados hasta más tarde.
                  Vacío = ese día usa el horario general de arriba. El cierre admite 24, 25… */}
              <div className="form-group">
                <label className="d-block"><small>Horario especial por día</small></label>
                <p className="text-muted mb-2" style={{ fontSize: 12 }}>
                  Dejá vacío para usar el horario general. Para cerrar a medianoche poné <strong>24</strong> (25 = 01:00).
                </p>
                <table className="table table-sm mb-0" style={{ maxWidth: 420 }}>
                  <thead>
                    <tr>
                      <th className="border-0"><small>Día</small></th>
                      <th className="border-0"><small>Apertura</small></th>
                      <th className="border-0"><small>Cierre</small></th>
                      <th className="border-0"><small>Última reserva</small></th>
                    </tr>
                  </thead>
                  <tbody>
                    {WEEKDAYS.map((wd, d) => (
                      <tr key={d}>
                        <td className="align-middle">{wd}</td>
                        {['openHour', 'closeHour', 'lastReservation'].map((key) => (
                          <td key={key}>
                            <input type="number" className="form-control form-control-sm" style={{ width: 80 }}
                              placeholder={String(s[key])}
                              value={this.overrideValue(d, key)}
                              onChange={(e) => this.setOverride(d, key, e.target.value)} />
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <button type="button" className="btn btn-primary btn-sm" disabled={this.state.busy} onClick={this.save}>
                {this.state.busy ? '...' : 'Guardar horario'}
              </button>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default ReservationSettingsComponent;
